import { styled } from '@mui/material/styles';
import { IconButton, Box } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const PreviewContainer = styled(Box)(() => ({
  position: 'relative',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.9,
    '& .slider-controls': {
      opacity: 1,
    },
  },
}));

export const PreviewImage = styled(Box)(() => ({
  width: '25.6rem',
  height: '16.8rem',
  backgroundColor: abyssColors.primary[50],
  borderRadius: '0.8rem',
  overflow: 'hidden',
}));

export const SliderNavButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'white',
  opacity: 0,
  transition: 'opacity 0.3s ease-in-out',
  width: '32px',
  height: '32px',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
}));

export const DotsContainer = styled(Box)(() => ({
  position: 'absolute',
  bottom: '12px',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
}));

export const DotIndicator = styled(Box)<{ isActive: boolean }>(({ isActive }) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: isActive ? 'white' : 'rgba(255, 255, 255, 0.5)',
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    backgroundColor: 'white',
    transform: 'scale(1.2)',
  },
}));

const BaseFlexContainer = styled(Box)<{ containerHeight?: string | number }>(
  ({ containerHeight = '100%' }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: containerHeight,
    minHeight: '80px',
    background: abyssColors.neutral[100],
    borderRadius: '5px',
    fontSize: '12px',
    color: abyssColors.neutral[600],
    textAlign: 'center',
  })
);

export const EmptyPlaceholder = styled(BaseFlexContainer)(() => ({
  height: '100px',
}));

export const ThumbnailLoadingContainer = styled(BaseFlexContainer)(() => ({
  padding: '8px',
}));
